import { createApi } from '@reduxjs/toolkit/query/react';

import { INTERNAL_ERROR_STATUS_CODE } from '@/constants';
import { getCitiesListApiRequestUrl, request } from '@/utils';

export const citiesApi = createApi({
  reducerPath: 'cities',
  endpoints: (builder) => ({
    getCitiesList: builder.query({
      queryFn: async ({ locale }) => {
        try {
          const response = await request(
            getCitiesListApiRequestUrl({
              locale,
            })
          );

          return {
            data: response?.data || {},
          };
        } catch (error) {
          console.error('getCitiesList error:', error);

          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCitiesListQuery,
  util: { getRunningQueriesThunk: getRunningOperationPromisesCities },
} = citiesApi;

// export endpoints for use in SSR
export const { getCitiesList } = citiesApi.endpoints;
